(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alr-produse-rand"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scrollers = () => {
      document.querySelectorAll('.alr-rand:not([data-alr-init])').forEach((root) => {
        root.dataset.alrInit = '1';
        const lista = root.querySelector('.alr-rand__lista');
        root.querySelectorAll('.alr-rand__btn').forEach((btn) =>
          btn.addEventListener('click', () => {
            lista.scrollBy({ left: Number(btn.dataset.dir) * lista.clientWidth * 0.9, behavior: 'smooth' });
          })
        );
      });
    };

    const KEY = 'alr_recente';
    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(KEY) || '[]');
      } catch (e) {
        return [];
      }
    };
    const write = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
    };

    const recente = async () => {
      const root = document.querySelector('[data-alr-recente]:not([data-alr-loaded])');
      if (!root) return;
      root.dataset.alrLoaded = '1';
      const current = root.dataset.current;
      const max = Number(root.dataset.max) || 12;
      const prev = read().filter((h) => h && h !== current);
      const handles = prev.slice(0, max);
      if (!handles.length) return;
      const base = window.Shopify?.routes?.root || '/';
      const html = await Promise.all(
        handles.map((h) =>
          fetch(`${base}products/${h}?section_id=alr-mini-card`)
            .then((r) => (r.ok ? r.text() : ''))
            .catch(() => '')
        )
      );
      const lista = root.querySelector('.alr-rand__lista');
      const parser = new DOMParser();
      html.forEach((t) => {
        if (!t) return;
        const li = parser.parseFromString(t, 'text/html').querySelector('.alr-rand__item');
        if (li) lista.append(li);
      });
      if (lista.children.length) root.hidden = false;
    };

    // „Vizualizate recent” e la finalul paginii: cardurile se aduc doar când vizitatorul ajunge aproape de ea
    const recenteLazy = () => {
      const root = document.querySelector('[data-alr-recente]:not([data-alr-loaded])');
      if (!root) return;
      const conn = navigator.connection || {};
      const current = root.dataset.current;
      if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) {
        // pe net foarte lent doar ținem minte produsul, fără să aducem carduri
        if (current) write([current, ...read().filter((h) => h && h !== current)].slice(0, 20));
        root.dataset.alrLoaded = '1';
        return;
      }
      const sentinel = root.parentElement || root;
      if (!('IntersectionObserver' in window)) return recente();
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          io.disconnect();
          (window.requestIdleCallback || setTimeout)(() => recente());
        },
        { rootMargin: '600px' }
      );
      io.observe(sentinel);
      // produsul curent se ține minte imediat, chiar dacă vizitatorul nu derulează până jos
      if (current) write([current, ...read().filter((h) => h && h !== current)].slice(0, 20));
    };

    scrollers();
    recenteLazy();
    document.addEventListener('shopify:section:load', () => {
      scrollers();
      recenteLazy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alr-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alr-slideshow')) {
    customElements.define(
      'alr-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          this.pista = this.querySelector('.alr-ss__pista');
          this.slides = [...this.querySelectorAll('.alr-ss__slide')];
          this.puncte = [...this.querySelectorAll('.alr-ss__punct')];
          if (this.slides.length < 2) return;
          this.index = 0;

          this.querySelectorAll('.alr-ss__sageata').forEach((b) =>
            b.addEventListener('click', () => this.mergi(this.index + Number(b.dataset.dir)))
          );
          this.puncte.forEach((p) => p.addEventListener('click', () => this.mergi(Number(p.dataset.i))));

          // slide-ul activ se află din derulare (merge și la swipe cu degetul)
          let cadru = 0;
          this.pista.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(cadru);
              cadru = requestAnimationFrame(() => {
                const i = Math.round(this.pista.scrollLeft / this.pista.clientWidth);
                if (i !== this.index) this.activ(i);
              });
            },
            { passive: true }
          );

          // derulare automată: doar dacă e cerută, nu la „reduce motion”, doar cât e pe ecran și nu e atins
          const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.interval = Number(this.dataset.interval) || 6000;
          if (this.dataset.autoplay === 'true' && !reduce) {
            this.pauza = false;
            const opreste = () => (this.pauza = true);
            const porneste = () => (this.pauza = false);
            this.addEventListener('mouseenter', opreste);
            this.addEventListener('mouseleave', porneste);
            this.addEventListener('focusin', opreste);
            this.addEventListener('focusout', porneste);
            this.pista.addEventListener('touchstart', opreste, { passive: true });
            this.pista.addEventListener('touchend', () => setTimeout(porneste, 4000), { passive: true });
            new IntersectionObserver(([e]) => (e.isIntersecting ? this.start() : this.stop())).observe(this);
          }

          // în editorul temei: la selectarea unui slide, arată-l
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.slides.indexOf(e.target);
            if (i > -1) {
              this.stop();
              this.mergi(i);
            }
          });
        }
        disconnectedCallback() {
          this.stop();
        }
        start() {
          this.stop();
          this.timer = setInterval(() => {
            if (!this.pauza && !document.hidden) this.mergi(this.index + 1);
          }, this.interval);
        }
        stop() {
          clearInterval(this.timer);
        }
        mergi(i) {
          const n = this.slides.length;
          i = (i + n) % n;
          this.pista.scrollTo({ left: i * this.pista.clientWidth });
          this.activ(i);
        }
        activ(i) {
          this.index = i;
          this.puncte.forEach((p, j) => p.setAttribute('aria-current', j === i ? 'true' : 'false'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
